export const benchmarkFilter = (benchmarks: any, value: string) => {
  return (
    benchmarks.includes(value) ||
    value.startsWith('Fixed benchmark - ') ||
    value.startsWith('benchmark-')
  );
};

export const benchmarkSort = (benchmarks: any) => {
  return (a: any, b: any) => {
    const first = benchmarks.indexOf(a.value || a);
    const second = benchmarks.indexOf(b.value || b);

    if (first < second) {
      return -1;
    }
    if (first > second) {
      return 1;
    }
    return 0;
  };
};

export const fullBenchmarkSort = (benchmarks: any) => {
  return (a: string, b: string) => {
    const first = benchmarkFilter(benchmarks, a);
    const second = benchmarkFilter(benchmarks, b);

    if (!first && second) {
      return -1;
    }
    if (first && !second) {
      return 1;
    }
    if (first && second) {
      return benchmarkSort(benchmarks)(a, b);
    }

    return 0;
  };
};

export const formatName = (name: string) => {
  if (name.startsWith('benchmark-')) {
    return name.replace('benchmark-', '');
  }

  return name;
};
